// src/app/pages/auth/login/login.styles.ts
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { alpha } from '../../../themes/brand';

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.background};
  transition: all 0.3s ease;
`;

export const LoginBox = styled.div`
  background-color: ${({ theme }) => theme.background};
  border-radius: 10px;
  padding: 2rem;
  width: 100%;
  max-width: 400px;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const LoginTitle = styled.h1`
  color: ${({ theme }) => theme.text};
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.5rem;
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LoginInput = styled.input`
  padding: 0.75rem;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.border};
  background-color: ${({ theme }) => theme.input.background};
  color: ${({ theme }) => theme.text};
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
    box-shadow: 0 0 0 2px ${({ theme }) => alpha(theme.primary, 0.2)};
  }

  &::placeholder {
    color: ${({ theme }) => theme.placeholderColor};
  }
`;

export const LoginButton = styled.button`
  padding: 0.75rem;
  border-radius: 5px;
  border: none;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.primaryHover};
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.error};
  background-color: ${({ theme }) => theme.errorBackground};
  padding: 0.75rem;
  border-radius: 5px;
  margin-bottom: 1rem;
  text-align: center;
`;

// Novos componentes estilizados
export const MfaMessage = styled.div`
  text-align: center;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 14px;
  line-height: 1.4;
`;

export const EmailHighlight = styled.span`
  font-weight: 700;
`;

export const ForgotPasswordLink = styled(Link)`
  display: block;
  margin-top: 15px;
  text-align: center;
  color: ${({theme}) => theme.text};
  font-size: 14px;
  text-decoration: underline;
  
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.primaryAccent};
  }
`; 